const PanelPaths = {
    dashboard: '/panel/dashboard',
    orders: '/panel/orders',
    comments: '/panel/comments',
    userAccount: "/panel/user-account",
    label: (id) => id ? `/panel/label/${id}` : '/panel/label',
    invoice: (id) => id ? `/panel/invoice/${id}` : '/panel/invoice',
    admin: {
        articlesCategories: '/panel/articles/categories',
        articlesList: '/panel/articles/list',
        servicesCategories: '/panel/services/categories',
        servicesList: '/panel/services/list',
        customerClub: {
            clubs: "/panel/customer-club/clubs",
            rating: "/panel/customer-club/rating",
            event: "/panel/customer-club/events",
        },
        //piecesFeatures: '/panel/pieces/featureGroups',
        //piecesCategories: '/panel/pieces/categories',
        //piecesList: '/panel/pieces/list',
        //pieceFeatureGroups: '/panel/piece/features',
        productsList: '/panel/product/list',
        productsFeatures: '/panel/product/featureGroups',
        productsCategories: '/panel/product/categories',
        productsFeatureGroups: '/panel/product/features',
        productsAttributeGroups: '/panel/product/attribute',
        productGroupOffer: '/panel/group-offer',
        serviceCategories: '/panel/service/categories',
        wareHouse: '/panel/warehouse',
        catalogCategories: '/panel/catalog/categories',
        catalogsList: '/panel/catalog/list',
        //doorsCategories: '/panel/doors/categories',
        //doorsList: '/panel/doors/list',
        //doorFeatureGroups: '/panel/door/features',
        //doorPieces: '/panel/doors/pieces',
        websiteSliders: '/panel/website/sliders',
        websiteCatalogue: '/panel/website/catalogue',
        websiteGallery: '/panel/website/gallery',
        websiteBusinessGallery: '/panel/website/business-gallery',
        websiteBanners: '/panel/website/banners',
        //websiteDoorsCategoryBanners: '/panel/website/door-category-banners',
        //websitePiecesCategoryBanners: '/panel/website/piece-category-banners',
        websiteProductCategoryBanners: '/panel/website/product-category-banners',
        websiteFaq: '/panel/website/faq',
        AccountingSystems: '/panel/website/accounting-systems',
        websiteGuide: '/panel/website/guide',
        websiteMenu: '/panel/website/menu',
        websiteSettings: '/panel/website/settings',
        mediaImages: '/panel/media/images',
        adminSmsSetting: '/panel/admin-sms-setting',
        customerSmsSetting: '/panel/customer-sms-setting',
        roles: '/panel/users/roles',
        customers: '/panel/users/customers',
        coWorker: '/panel/users/co-worker',
        personnel: '/panel/users/personnel',
        showOrder: '/panel/admin-orders',
        invoices: '/panel/admin-invoices',
        optionalInvoices: '/panel/admin/optional-invoices',
        coupons: '/panel/coupons',
        deliveryMethods: '/panel/delivery-methods',
        comments: '/panel/comments',
        profile: '/panel/profile',
        websiteStories: '/panel/stories',
        //productionManagement: '/panel/production-management',
        //productionManagementReference: '/panel/production-management-reference',
        logs: "/panel/logs",
        //productionReports: '/panel/production-reports',
        contactRequests: '/panel/contact-requests',
        ReservationRequest: '/panel/agency',
        customerBrand: '/panel/parties-to-the-contract',
        brand: '/panel/brand',
        tags: '/panel/tags',
        commercialPartners: '/panel/commercial-partners',
        attribute: (id) => id ? `/panel/attribute/${id}` : '/panel/attribute',
        transaction: '/panel/transaction',
        fieldMaker: {
            fields: '/panel/field-maker',
            options: '/panel/field-maker/options'
        },
        variables: '/panel/variables',
        gateways: '/panel/gateways'
    },
    discharger: {
        discharge: "/panel/discharge"
    },
    customer: {
        showOrder: "/panel/customer/orders",
        favorite: '/panel/customer-favorite',
        customerDoors: '/panel/customer-doors',
        customerDoor: '/panel/customer-doors/:id',
        addresses: '/panel/customer-address',
        invoices: '/panel/customer-invoice'
    },
    production: {
        orders: '/panel/production-personnel-management'
    },
    seo: {
        redirects: "/panel/redirects",
        pages: "/panel/pages",
    }
}

export default PanelPaths
